import { useEffect, useState } from 'react';
import { languageParts, currentLocale } from '@trello/locale';
import {
  sendChunkLoadErrorEvent,
  sendErrorEvent,
} from '@trello/error-reporting';
import { importWithRetry } from '@trello/use-lazy-component';

const getMediaMessages = async (msgType: string) => {
  switch (msgType) {
    case 'cs':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-cs" */ '@atlaskit/media-ui/dist/esm/i18n/cs'
          ),
      );
    case 'da':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-da" */ '@atlaskit/media-ui/dist/esm/i18n/da'
          ),
      );
    case 'de':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-de" */ '@atlaskit/media-ui/dist/esm/i18n/de'
          ),
      );
    case 'en_GB':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-en_GB" */ '@atlaskit/media-ui/dist/esm/i18n/en_GB'
          ),
      );
    case 'es':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-es" */ '@atlaskit/media-ui/dist/esm/i18n/es'
          ),
      );
    case 'et':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-et" */ '@atlaskit/media-ui/dist/esm/i18n/et'
          ),
      );
    case 'fi':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-fi" */ '@atlaskit/media-ui/dist/esm/i18n/fi'
          ),
      );
    case 'fr':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-fr" */ '@atlaskit/media-ui/dist/esm/i18n/fr'
          ),
      );
    case 'hu':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-hu" */ '@atlaskit/media-ui/dist/esm/i18n/hu'
          ),
      );
    case 'is':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-is" */ '@atlaskit/media-ui/dist/esm/i18n/is'
          ),
      );
    case 'it':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-it" */ '@atlaskit/media-ui/dist/esm/i18n/it'
          ),
      );
    case 'ja':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-ja" */ '@atlaskit/media-ui/dist/esm/i18n/ja'
          ),
      );
    case 'ko':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-ko" */ '@atlaskit/media-ui/dist/esm/i18n/ko'
          ),
      );
    case 'nb':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-nb" */ '@atlaskit/media-ui/dist/esm/i18n/nb'
          ),
      );
    case 'nl':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-nl" */ '@atlaskit/media-ui/dist/esm/i18n/nl'
          ),
      );
    case 'pl':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-pl" */ '@atlaskit/media-ui/dist/esm/i18n/pl'
          ),
      );
    case 'pt_BR':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-pt_BR" */ '@atlaskit/media-ui/dist/esm/i18n/pt_BR'
          ),
      );
    case 'pt_PT':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-pt_PT" */ '@atlaskit/media-ui/dist/esm/i18n/pt_PT'
          ),
      );
    case 'ro':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-ro" */ '@atlaskit/media-ui/dist/esm/i18n/ro'
          ),
      );
    case 'ru':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-ru" */ '@atlaskit/media-ui/dist/esm/i18n/ru'
          ),
      );
    case 'sk':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-sk" */ '@atlaskit/media-ui/dist/esm/i18n/sk'
          ),
      );
    case 'sv':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-sv" */ '@atlaskit/media-ui/dist/esm/i18n/sv'
          ),
      );
    case 'th':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-th" */ '@atlaskit/media-ui/dist/esm/i18n/th'
          ),
      );
    case 'tr':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-tr" */ '@atlaskit/media-ui/dist/esm/i18n/tr'
          ),
      );
    case 'uk':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-uk" */ '@atlaskit/media-ui/dist/esm/i18n/uk'
          ),
      );
    case 'vi':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-vi" */ '@atlaskit/media-ui/dist/esm/i18n/vi'
          ),
      );
    case 'zh':
    case 'zh-Hans':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-zh" */ '@atlaskit/media-ui/dist/esm/i18n/zh'
          ),
      );
    case 'zh_TW':
    case 'zh-Hant':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "media-messages-zh-tw" */ '@atlaskit/media-ui/dist/esm/i18n/zh_TW'
          ),
      );
    default:
      return importWithRetry(
        () =>
          import(
            /* webpackChunkName: "media-messages-en" */ '@atlaskit/media-ui/dist/esm/i18n/en'
          ),
      );
  }
};

export const useMediaLocale = () => {
  const [messages, setMessages] = useState({});
  const [isLocaleReady, setIsLocaleReady] = useState(false);
  const { language, region, script } = languageParts(currentLocale);

  useEffect(() => {
    const mediaMsgType = region
      ? `${language}_${region}`
      : script
      ? `${language}-${script}`
      : language;
    const setLocaleData = async () => {
      try {
        const mediaMessages = await getMediaMessages(mediaMsgType);

        setMessages(mediaMessages.default);
        setIsLocaleReady(true);
      } catch (error) {
        setIsLocaleReady(true);
        setMessages({});
        if (error instanceof Error) {
          if (error.name === 'ChunkLoadError') {
            sendChunkLoadErrorEvent(error);
          } else {
            sendErrorEvent(error, {
              tags: {
                ownershipArea: 'trello-teamplates',
                feature: 'Smart Link',
              },
            });
          }
        }
      }
    };

    setLocaleData();
  }, [setMessages, script, region, language]);

  return {
    messages,
    isLocaleReady,
  };
};
